module.exports = __webpack_public_path__ + "static/img/16.c347f71.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/4/eng/16.png
// module id = NeXa
// module chunks = 0